// extracted by mini-css-extract-plugin
module.exports = {"outerContainer":"_a6481150","innerContainer":"_98eac7d7","content":"_842c08a7","title":"_7adf630e"};